module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg16-f555a426390c795b3890dbaa0bf44d8c.png";